<template>
    <transition name="fade" mode="out-in" appear>
        <div :key="isVisible" id="dots" v-if="loaded && isVisible">
            <div class="dot" v-for="(color, i) in colors" :key="color+i">
                <div class="inner" v-bind:style="{ background: color }">
                    <div :class="'highlight delay-' + i" :id="'dot' + (i + 1)" v-bind:style="{ background: color }">
                    </div>
                    <div class="text">{{i + 1}}</div>
                </div>
            </div>    
        </div>
    </transition>
</template>


<script>
import eventBus from "../eventBus";
import Velocity from "velocity-animate";

export default {
  name: "dots",
  props: ["combination", "isVisible"],
  data() {
    return {
      loaded: false,
      colors: [],
      isHightlighting: false
    };
  },
  created() {
    this.colors = window.colors;
    this.fetchData(() => (this.loaded = true));
    eventBus.$on("highlight", this.highlight);
  },
  beforeDestroy() {
    //Console: "TypeError: Cannot read property '0' of undefined at eval..." -> https://github.com/cklmercer/vue-events/issues/11
    eventBus.$off("highlight", this.highlight);
  },
  methods: {
    fetchData(callback) {
      if (callback) callback();
    },
    unhighlight() {
      var doms = document.getElementsByClassName("highlight");
      for (var i = 0; i < doms.length; i++) {
        Velocity(
          doms[i],
          {
            width: 100 + "%",
            height: 100 + "%",
            top: 0 + "%",
            left: 0 + "%"
          },
          {
            duration: 250,
            easing: "easeOutQuad"
          }
        );
      }
    },
    highlight(duration) {
      if (this.isHightlighting) return;
      this.isHightlighting = true;
      duration = duration ? duration : 1500;
      this.unhighlight();
      setTimeout(() => {
        for (var i = 0; i < this.combination.length; i++) {
          let index = this.combination[i];
          var dom = document.getElementById("dot" + index);

          Velocity(
            dom,
            {
              width: 180 + "%",
              height: 180 + "%",
              top: -40 + "%",
              left: -40 + "%"
            },
            {
              duration: 500,
              delay: (duration * i) + 1000,
              easing: "easeInQuad",
              begin: elements => {
                var audio = window.audios[index - 1];
                audio.volume = window.volume;
                if (audio) {
                  audio.pause();
                  audio.currentTime = 0;
                  var playPromise = audio.play();
                  if (playPromise !== undefined) {
                    playPromise.then(_ => {}).catch(error => {});
                  }
                }
              }
            }
          );
        }
      }, 500);

      setTimeout(() => {
        this.unhighlight();
        this.isHightlighting = false;
      }, this.combination.length * duration + 2500);
    },
    clearData() {
      this.colors = [];
    }
  }
};
</script>

<style lang="scss">
@import "../style/animate.css";
@import "../style/transitions.scss";
@import "../style/basic.scss";

#dots {
  position: absolute;
  width: 80%;
  left: 10%;
  right: 10%;
  margin-top: 10px;
  margin-bottom: 10px;
  bottom: 100px;

  padding-top: 50px;
  padding-bottom: 30px;
  z-index: 10;

  .dot {
    float: left;
    display: table;
    width: 1 / 8 * 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    .inner {
      position: relative;
      width: 80px / (1080px * 0.15) * 100%;
      border-radius: 50%;
      margin: 0 auto;

      .text {
        position: absolute;
        width: 100%;
        top: 0;
        text-align: center;
        margin-top: 50%;
        transform: translateY(-50%);
        font-size: 1.5em;
        padding-top: 4px;
        font-family: 'DINPro-Bold', sans-serif;
        z-index: 2;
      }

      &:before {
        content: "";
        display: block;
        padding-top: 100%;
      }

      .highlight {
        z-index: 1;
        position: absolute;
        left: 0;
        border-radius: 50%;
        width: 100%;
        height: 100%;
        top: 0%;
        left: 0%;
        opacity: 0.5;

        &.active {
          width: 180%;
          height: 180%;
          top: -40%;
          left: -40%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dots.vue